export default __webpack_public_path__ + "static/media/sho4.29fe5677.jpg";